// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2U-8u","upload":"Small_upload__2Uf3v","imageWrap":"Small_imageWrap__212lW","removeBtn":"Small_removeBtn__2qT6-"};